import React from 'react'
import VericredDocumentImport from './VericredDocumentImport'

export default function ServiceAreasImport() {
  return (
    <VericredDocumentImport importType="service_areas" />
  )
}
